import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface TableColumn {
    key: string;
    label: string;
    width?: string;
    align?: 'left' | 'center' | 'right';
    headerClass?: string;
}

@Component({
    selector: 'app-table',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
})
export class TableComponent {
    // ponytail: row/cell template projection; upgrade path: add sort/filter events and pagination bindings
    @Input() columns: TableColumn[] = [];
    @Input() data: any[] = [];
    @Input() customClass = '';
    @Input() emptyTitle = 'Tidak Ada Data';
    @Input() emptyDescription = '';
    @Input() emptyIcon = 'inbox';
    @Input() trackByKey = 'id';

    @ContentChild('rowTemplate') rowTemplate?: TemplateRef<any>;
    @ContentChild('cellTemplate') cellTemplate?: TemplateRef<any>;
    @ContentChild('emptyTemplate') emptyTemplate?: TemplateRef<any>;

    trackByFn = (index: number, item: any): any => {
        return item?.[this.trackByKey] ?? index;
    };
}